import { useMutation, useQueryClient } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useAddressSuggestionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/address-suggestions`,
        method: "POST",
        body: { old_address: data },
      }),
    onSuccess: (response) => {
      queryClient.setQueryData(["address-suggestions"], response);
    },
  });
};
